/** @module Specification/PartMaterialQuantity/Matrix */
define([
	"dojo/_base/declare",
	"Specification/PartMaterialSize/Matrix",
	"../SizeVariationParams"
], function(declare, PartMaterialSizeVariationMatrix, {QTY_PARAMS}) {

	return declare(PartMaterialSizeVariationMatrix, {
		// the quantity matrix filter is driven by the size matrix filter, so not needed here
		bAllowColumnFilter: false,
		id: QTY_PARAMS.attr,
	});

});